const REFERRAL_CODE_PATTERN = /^[a-zA-Z0-9_-]+$/;
const REFERRAL_CODE_MAX_LENGTH = 255;

/**
 * Validates a referral code from the URL against the API's accepted format.
 * Returns the code if valid, or null if malformed/overlong so that
 * invalid referral codes never block checkout with a 422.
 * @param raw - Raw ?code= query parameter value
 * @returns Sanitized code or null
 */
export function sanitizeReferralCode(raw: string | null): string | null {
  if (!raw || raw.length > REFERRAL_CODE_MAX_LENGTH || !REFERRAL_CODE_PATTERN.test(raw)) {
    return null;
  }
  return raw;
}
